import {Group, GroupProps} from "../Group/Group";
import React, {forwardRef, useMemo} from "react";
import {ActionIcon} from "@mantine/core";
import {IconEdit, IconEye, IconTrash} from "@tabler/icons-react";
import {HasAccess} from "../../auth/HasAccess/HasAccess";
import {Entity} from "@ots-frontend/ots-data";

export type EntityActionGroupProps = GroupProps & {
  entity?: Entity
  permissionPrefix: string,
  viewPermission?: string
  editPermission?: string
  deletePermission?: string
  view?: boolean
  edit?: boolean
  delete?: boolean
  onViewActionClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void,
  onEditActionClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void,
  onDeleteActionClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void,
}

export const EntityActionGroup = forwardRef<HTMLDivElement, EntityActionGroupProps>((props, ref) => {
  const {
    entity,
    permissionPrefix,
    view = true,
    edit = true,
    delete: allowDelete = true,
    viewPermission = `view`,
    editPermission = `edit`,
    deletePermission = `delete`,
    onViewActionClick,
    onEditActionClick,
    onDeleteActionClick,
    spacing = 4,
    position = "right",
    noWrap = true,
    ...
      rest
  } = props;

  const accessObject = useMemo(() => {
    if (entity) {
      return {
        resource: entity.abacAttributes
      }
    }

    return undefined
  }, [entity])

  return (
    <Group {...rest} ref={ref} spacing={spacing} position={position} noWrap={noWrap}>
      {view &&
        <HasAccess object={accessObject} permissions={[`${permissionPrefix}_${viewPermission}`]}>
          <ActionIcon onClick={onViewActionClick}>
            <IconEye size={16}/>
          </ActionIcon>
        </HasAccess>
      }
      {edit &&
        <HasAccess object={accessObject} permissions={[`${permissionPrefix}_${editPermission}`]}>
          <ActionIcon onClick={onEditActionClick}>
            <IconEdit size={16}/>
          </ActionIcon>
        </HasAccess>
      }
      {allowDelete &&
        <HasAccess object={accessObject} permissions={[`${permissionPrefix}_${deletePermission}`]}>
          <ActionIcon color="red" onClick={onDeleteActionClick}>
            <IconTrash size={16}/>
          </ActionIcon>
        </HasAccess>
      }
    </Group>
  )
});
